/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class ManageStatusesModel {

        public addingNewStatusGroup: boolean;

        private systemLevel: Wars.Domain.Model.SystemLevel;

        constructor(
            private statusAndStateService: services.StatusAndStateService,
            private systemLevelService: services.SystemLevelService,
            private deleteService: services.DeleteService)
        {
            this.loadSystemLevelStatesAndStatuses();
        }

        private loadSystemLevelStatesAndStatuses(): void {
            this.systemLevelService.getSystemLevelStatusesAndStates().then((systemLevel) => {
                this.systemLevel = systemLevel;
            });
        }

        public addNewStatus(statusCodeGroup: Wars.Domain.Model.Statuses.StatusCodeGroup): void {
            var newStatus = this.statusAndStateService.createNewStatus();
            statusCodeGroup.myStatuses.push(newStatus);
            newStatus.myParentStatusGroup = statusCodeGroup;
            newStatus.parentStatusCodeGroup_id = statusCodeGroup.id;
            newStatus.shortDescription = "New Status";
            this.addNewState(newStatus, "Initial State");
            this.save();
        }

        public addNewState(statusCode: Wars.Domain.Model.Statuses.StatusCode, stateName?: string): void {
            var newState = this.statusAndStateService.createNewState();
            statusCode.myStates.push(newState);
            newState.myParentStatus = statusCode;
            newState.statusCode_id = statusCode.id;
            newState.shortDescription = stateName ? stateName : "New State";
            this.save();
        }

        public deleteStatus(status: Wars.Domain.Model.Statuses.StatusCode): void {
            this.deleteService.deleteWithModalConfirmationIfNecessary(
                "StatusCode",
                status.id,
                "Status successfully deleted",
                () => this.loadSystemLevelStatesAndStatuses(),
                "Status could not be deleted");
        }

        public deleteState(state: Wars.Domain.Model.Statuses.StateCode): void {
            this.deleteService.deleteWithModalConfirmationIfNecessary(
                "StateCode",
                state.id,
                "State successfully deleted",
                () => this.loadSystemLevelStatesAndStatuses(),
                "State could not be deleted");
        }

        private removeStatus(status: Wars.Domain.Model.Statuses.StatusCode): void {
            var systemStatusGroup = this.systemLevel.statusCodeGroup;
            for (var statusIndex = 0; statusIndex < systemStatusGroup.myStatuses.length; statusIndex++) {
                var currentStatus = systemStatusGroup.myStatuses[statusIndex];
                if (currentStatus.id === status.id) {
                    systemStatusGroup.myStatuses.splice(statusIndex, 1);
                }
            }
            
        }

        private removeState(state: Wars.Domain.Model.Statuses.StateCode): void {
            var systemStatusGroup = this.systemLevel.statusCodeGroup;
            for (var statusIndex = 0; statusIndex < systemStatusGroup.myStatuses.length; statusIndex++) {
                var currentStatus = systemStatusGroup.myStatuses[statusIndex];
                for (var stateIndex = 0; stateIndex < currentStatus.myStates.length; stateIndex++) {
                    var currentState = currentStatus.myStates[stateIndex];
                    if (currentState.id === state.id) {
                        currentStatus.myStates.splice(stateIndex, 1);
                    }
                }
            }
            
        }

        public save(): void {
            this.systemLevelService.saveAllChanges();
        }
    }
}